import type { FC } from 'react'
import { SvgIcon, SvgIconProps } from '@mui/material'

export const Plus: FC<SvgIconProps> = (props) => (
  <SvgIcon width="24" height="24" {...props}>
    <path d="M21 13h-8v8h-2v-8H3v-2h8V3h2v8h8v2z" />
  </SvgIcon>
)
